/**
* Created by lobin on 2020/6/18.
*/
<template>
  <div class="station">
    <a-card :body-style="{padding: '24px 32px'}" :bordered="false">
      <a-form-model
          ref="ruleForm"
          :model="form"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="选择公司" prop="company" v-if="type === 'add'">
          <company-search
              v-model="form.company"
              placeholder="请选择所属公司"
          />
        </a-form-model-item>
        <a-form-model-item label="站点名称" prop="name">
          <a-input
              v-model="form.name"
              placeholder="请输入站点名称"
          />
        </a-form-model-item>
        <a-form-model-item label="站点电话" prop="phone">
          <a-input
              v-model="form.phone"
              placeholder="请输入站点电话不能重复"
          />
        </a-form-model-item>
        <a-form-model-item label="站点省市区" prop="areaCode">
          <area-select v-model="form.areaCode" />
        </a-form-model-item>
        <a-form-model-item label="站点地址" prop="address">
          <a-input
              v-model="form.address"
              placeholder="请输入站点详细"
          />
        </a-form-model-item>
        <a-form-model-item label="快宝地址" prop="kauibaoalocId">
          <a-input
              v-model="form.kauibaoalocId"
              placeholder="请输入快宝地址id"
          />
        </a-form-model-item>
        <a-form-model-item label="快速投递" prop="fastDelivery" required>
          <a-switch v-model="form.fastDelivery" />
        </a-form-model-item>
        <a-form-model-item label="站点经纬度" prop="location">
          <a-input-group compact>
            <a-input style=" width: 100px; text-align: center;pointer-events: none" placeholder="经度" disabled v-model="form.location[0]" />
            <a-input
                style=" width: 30px; border-left: 0; pointer-events: none; backgroundColor: #fff"
                placeholder="~"
                disabled
            />
            <a-input style="width: 100px; text-align: center; border-left: 0;pointer-events: none" placeholder="纬度" disabled v-model="form.location[1]" />
            <a-button type="primary" @click="showslectLocation">选择</a-button>
          </a-input-group>
        </a-form-model-item>
        <a-form-model-item label="DTU类型" prop="dtuType">
          <a-select
              v-model="form.dtuType"
              placeholder="请选择DTU类型(不知道的请询问管理员)"
          >
            <a-select-option :value="item.value" :key="item.value" v-for="item in dtuType">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <!-- <a-form-model-item label="设备" prop="device">
          <device-select v-model="form.device" />
        </a-form-model-item> -->
        <a-form-model-item label="wifi热点" prop="wifiAp" v-if="['2','3'].includes(form.dtuType)">
          <a-switch v-model="form.wifiAp" />
        </a-form-model-item>
        <a-form-model-item label="主板类型" prop="mainboardType">
          <a-select
              v-model="form.mainboardType"
              placeholder="请选择主板类型(协议相同的都可以)"
          >
            <a-select-option :value="item.value" :key="item.value" v-for="item in mainboardTypes">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="锁位判断" prop="lockJud">
          <a-radio-group v-model="form.lockJud">
            <a-radio value="0">
              正
            </a-radio>
            <a-radio value="1">
              反
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="柜子组数量" prop="cabinetNums">
          <a-input-number
              v-model="form.cabinetNums"
              placeholder="柜子组数量"
          />
        </a-form-model-item>
        <a-form-model-item label="灯光控制" prop="lightControl" required>
          <a-input-group compact>
            <a-select default-value="1" v-model="form.lightControl" style=" width: 72px;">
              <a-select-option value="1">
                开启
              </a-select-option>
              <a-select-option value="0">
                关闭
              </a-select-option>
            </a-select>
            <a-time-picker style=" width: 100px; " placeholder="开灯时间" v-model="form.lightStar" format="HH:mm" />
            <a-time-picker style=" width: 100px; " placeholder="关灯时间" v-model="form.lightEnd" format="HH:mm" />
          </a-input-group>
        </a-form-model-item>
        <a-form-model-item label="派件收费" prop="deliverCharge">
          <a-switch v-model="form.deliverCharge" />
        </a-form-model-item>
        <a-form-model-item label="格子价格" prop="smallBoxUnitPrice" required>
          <a-input-group compact>
            <a-input-number v-model="form.miniBoxUnitPrice" placeholder="迷你格子单价" />
            <a-input-number v-model="form.smallBoxUnitPrice" placeholder="小格子单价" />
            <a-input-number v-model="form.mediumBoxUnitPrice" placeholder="中格子单价" />
            <a-input-number v-model="form.bigBoxUnitPrice" placeholder="大格子单价" />
            <a-input-number v-model="form.hugeBoxUnitPrice" placeholder="超大格子单价" />
          </a-input-group>
        </a-form-model-item>
        <a-form-model-item label="取件收费" prop="getPksCharge" required>
          <a-switch v-model="form.getPksCharge" />
        </a-form-model-item>
        <a-form-model-item label="超期设置" prop="freeTime" required>
          <a-input-group compact>
            <a-input-number placeholder="免费时间(小时)" v-model="form.freeTime" />
            <a-input-number placeholder="收费间隔(小时)" v-model="form.timeInterval"/>
            <a-input-number placeholder="间隔单价(元)" v-model="form.intervalFee"/>
            <a-input-number placeholder="封顶(元)" v-model="form.maxOverTimeFee"/>
          </a-input-group>
        </a-form-model-item>
        <a-form-model-item label="单号查询" prop="pickByCode">
          <a-switch v-model="form.pickByCode" />
        </a-form-model-item>
        <a-form-model-item label="隐私号码带出" prop="secretSimilar">
          <a-switch v-model="form.secretSimilar" />
        </a-form-model-item>
        <a-form-model-item label="包裹过期时间" prop="expirationTime">
            <a-input-number placeholder="包裹过期时间(小时)" v-model="form.expirationTime" style="width: 160px" />
        </a-form-model-item>
        <a-form-model-item label="站点有效期" prop="validityTime">
          <a-date-picker v-model="form.validityTime" placeholder="站点有效期" />
        </a-form-model-item>
        <a-form-model-item label="站点状态" prop="status">
          <a-radio-group v-model="form.status">
            <a-radio :value="item.value" name="type" v-for="item in stationStatus" :key="item.value">
              {{ item.name }}
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remark">
          <a-input v-model="form.remark" type="textarea" />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 8, offset: 8 }">
          <a-button type="primary" @click="onSubmit" :loading="submiting">
            提交
          </a-button>
          <a-button style="margin-left: 10px;" @click="resetForm">
            重置
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
    <location-select ref="locationSelect" @change="locationSelected" />
  </div>
</template>

<script type="text/babel">
import { mapGetters } from 'vuex';
import moment from 'moment';
import { createStation, stationModify, stationDetail } from '@/api/station';
import { CodeToText } from 'element-china-area-data';
import LocationSelect from '../../components/LocationSelect.vue';

export default {
  components: {
    LocationSelect,
  },
  data() {
    return {
      labelCol: { span: 8 },
      wrapperCol: { span: 10 },
      other: '',
      submiting: false,
      type: 'add',
      id: '',
      form: {
        company: '',
        name: '',
        phone: '',
        wifiAp: false,
        areaCode: [],
        location: [],
        mainboardType: '',
        lightControl: '1',
        getPksCharge: true,
        deliverCharge: true,
        status: '1',
      },
    };
  },
  created() {
    const { id } = this.$route.params;
    this.id = id;
    if (id) {
      this.type = 'modify';
      this.getDetail();
    }
  },
  computed: {
    ...mapGetters(['dtuType', 'stationStatus', 'mainboardTypes']),
    rules() {
      return {
        company: [
          { required: true, message: '请选择所属公司', trigger: 'blur' },
        ],
        // device: [
        //   { required: true, message: '请选择设备', trigger: 'chang' },
        // ],
        name: [
          { required: true, message: '请输入站点全称', trigger: 'blur' },
        ],
        fastDelivery: [
          { required: true, message: '请选择是否支持快速派件', trigger: 'change' },
        ],
        phone: [
          { required: true, message: '请输入站点电话', trigger: 'blur' },
        ],
        address: [
          { required: true, message: '请输入站点地址', trigger: 'blur' },
        ],
        areaCode: [
          { required: true, message: '请选择站点省市区', trigger: 'chagne' },
        ],
        location: [
          { required: true, message: '请选择经纬度', trigger: 'chagne' },
        ],
        dtuType: [
          { required: true, message: '请选择dtu类型', trigger: 'chagne' },
        ],
        mac: [
          { required: true, message: '输入dtu的mac', trigger: 'blur' },
        ],
        mainboardType: [
          { required: true, message: '请选择主板类型', trigger: 'chagne' },
        ],
        lockJud: [
          { required: true, message: '请选择锁位', trigger: 'chagne' },
        ],
        cabinetNums: [
          { required: true, message: '请输入柜子组数', trigger: 'blur' },
        ],
        // lightControl: [
        //   { required: true, message: '请选择是否控制灯光', trigger: 'change' },
        // ],
        deliverCharge: [
          { required: true, message: '请选择是否派件收费', trigger: 'change' },
        ],
        getPksCharge: [
          { required: true, message: '请选择取件是否收费', trigger: 'change' },
        ],
        expirationTime: [
          { required: true, message: '请选择取件是否收费', trigger: 'blur' },
        ],
        validityTime: [
          { required: true, message: '请选择取件站点有效时间', trigger: 'chagne' },
        ],
        status: [
          { required: true, message: '请选择站点状态', trigger: 'chagne' },
        ],
      };
    },
  },
  methods: {
    async getDetail() {
      const { data } = await stationDetail(this.id);
      data.validityTime = moment(data.validityTime);
      data.lightStar = moment(data.lightStar, 'HH:mm');
      data.lightEnd = moment(data.lightEnd, 'HH:mm');
      data.lightControl = data.lightControl ? '1' : '0';
      this.form = data;
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.sumbitData();
          return true;
        }
        return false;
      });
    },
    async sumbitData() {
      this.submiting = true;
      const message = '提交成功';
      let res;
      if (this.type === 'modify') {
        const { areaCode } = this.form;
        this.form.area = [
          CodeToText[areaCode[0]],
          CodeToText[areaCode[1]],
          CodeToText[areaCode[2]],
        ];
        res = await stationModify(this.id, this.form);
      } else {
        res = await createStation(this.form);
      }
      if (res.code !== 0) {
        this.$message.fail(res.message);
      }
      if (res.data) {
        this.$message.success(message);
        this.resetForm();
      }
      this.submiting = false;
    },
    showslectLocation() {
      this.$refs.locationSelect.show();
    },
    locationSelected({ location }) {
      this.form.location = [location.lng, location.lat];
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
  },
};

</script>

<style lang="less" rel="stylesheet/less">
.station {
}
</style>
